import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import MainLandFreight from '../entities/mainlandfreight'
import appconst from '@/lib/appconst';


interface MainLandFreightState extends ListState<MainLandFreight> {
    total: any;
    MainLandFreightInfo: MainLandFreight,
}

class MainLandFreightMutations extends ListMutations<MainLandFreight>{

}
class MainLandFreightInfo extends ListModule<MainLandFreightState, any, MainLandFreight>{
    state = {
        totalCount: 0,
        total:0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<MainLandFreight>(),
        loading: false,
        mainlandfreights: MainLandFreight,
        id: 0,

    }
    actions = {
        async getAll(context: ActionContext<MainLandFreightState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MainlandFreight/GetMainLandFreightList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<MainLandFreight>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async Add(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/MainlandFreight/Add', payload.data);
        },
        async updateStatus(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/MainlandFreight/Edit', payload.data);
        },
        async GetFreight(context: ActionContext<MainLandFreightState, any>, payload: any) {
            let rep = await Ajax.post('/api/services/app/MainlandFreight/GetFreight', payload.data);
            let page = rep.data.result;
            context.state.total = page;
        },
        async editEndTime(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/MainlandFreight/EditEndTime', payload.data);
        },
    };
}

const mainlandfeightinfo = new MainLandFreightInfo();
export default mainlandfeightinfo;